exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".creator-score {\n  background-color: #3498db;\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  color: #ffffff;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: center;\n      justify-content: center;\n  -ms-flex-align: center;\n      align-items: center;\n  font-size: 16px;\n  font-weight: bold; }\n  .creator-score.creator-score--large {\n    width: 60px;\n    height: 60px;\n    font-size: 20px; }\n  .creator-score.level-one {\n    background-color: #e74b3d; }\n  .creator-score.level-two {\n    background-color: #e67d22; }\n  .creator-score.level-three {\n    background-color: #f1c411; }\n  .creator-score.level-four {\n    background-color: #2ecc71; }\n  .creator-score.level-five {\n    background-color: #27ae60; }\n  .creator-score.level-six {\n    background-color: #289155; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /root/social-native/socialnative-web/node_modules/css-loader!/root/social-native/socialnative-web/node_modules/postcss-loader/src??ref--4-2!/root/social-native/socialnative-web/node_modules/sass-loader/lib/loader.js!../scss/creator_score.scss
// module id = 2668
// module chunks = 69